import PropTypes from 'prop-types';
import React from 'react';

import { Link } from '@powdr/components/link';

export const EVENT_CALENDAR_EVENT_LINK_CLASS = 'event-calendar-event-link';

export const EventCalendarEventWrapper = ({ children = null, event = null }) => {
  if (!event?.url) return children;

  return (
    <Link
      className={EVENT_CALENDAR_EVENT_LINK_CLASS}
      href={event.url}
      title={event.title}
    >
      {children}
    </Link>
  );
};

EventCalendarEventWrapper.propTypes = {
  children: PropTypes.node,
  event: PropTypes.shape({
    title: PropTypes.string,
    url: PropTypes.string,
  }),
};
